export default __webpack_public_path__ + "static/media/login-background-space.a3e21857.jpg";